// removed by extract-text-webpack-plugin
module.exports = {"section":"Yc34KESxb6BwdHpvqUeon","thanks_wrapper":"_2C6e36oOvaGJrLa3hTIJVi","canvasContainer":"_1efsFwFHK4sY26MIX-kLOB","luck":"_3iNVAfFp70MMsWClJ15VWY","thanks":"_3eAG2h7OVhsY_kTykXNC0M","thank_wrapper01":"_1ZnJdRczAONaXo6wbdj7hg","thank_wrapper02":"_1hHR7WxBnaxzjYNuzVMTHa","thank_wrapper03":"_1bpd_hGBM5yz-m8ETDiPgL","luck_wrapper":"_1CUQ47O5qW7kW1oUix77A3","luck_span":"_2HBzqxWLLjvnb0qhI9Bx8Y"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FishVideo/FishVideo.module.css
 ** module id = 229
 ** module chunks = 0
 **/